import * as types from './types';

export const dtGPTMutations = {
  [types.DtGPTChats.SET.ALL](state, chats) {
    state.chats = chats;
  },
  [types.DtGPTConversations.SET.ALL](state, conversations) {
    state.conversations = conversations;
  },
  [types.DtGPTChat.SET.SINGLE](state, chat) {
    state.chat = chat;
  },
  [types.SET_SEND_CHAT_MESSAGE_LOADING](state, isLoading) {
    state.sendChatMessageLoading = isLoading;
  }
}